<div class="veo31-dialog">
    <div class="veo31-header">
      <button type="button" class="close-btn" (click)="close()" aria-label="Close Google Veo 3.1 Info">
        &times;
      </button>
  
      <img src="assets/logos/google.svg" alt="Google Veo 3.1 Logo" class="veo31-logo" />
      <h2>Google Veo 3.1</h2>
      <span class="badge-optimal">Text-to-Video • Camera Control • Film-Grade Detail</span>
    </div>
  
    <div class="veo31-body">
  
      <p class="intro">
        <strong>Google Veo 3.1</strong> is an advanced
        <span class="highlight">text-to-video generation model</span>
        designed to produce high-quality, cinematic video clips from natural language prompts.
        It’s built for controlled motion, consistent framing, and film-like composition —
        making it ideal for storyboarding, marketing concepts, and rapid pre-visualization.
        <br /><br />
        <strong>Created by:</strong> <span class="highlight">Google</span>
      </p>
  
      <ul class="qualities">
        <li>
          <span class="icon">🎬</span>
          <span>
            <strong>Cinematic Visual Quality:</strong>
            Generates video with strong lighting, composition, and detail for film-like results.
          </span>
        </li>
  
        <li>
          <span class="icon">📷</span>
          <span>
            <strong>Camera & Shot Direction:</strong>
            Responds well to prompts specifying shot type, lens feel, and movement (e.g., dolly, pan, handheld).
          </span>
        </li>
  
        <li>
          <span class="icon">🏃‍♂️</span>
          <span>
            <strong>Smoother Motion:</strong>
            Produces more coherent motion and scene flow for more believable clips.
          </span>
        </li>
  
        <li>
          <span class="icon">🧠</span>
          <span>
            <strong>Prompt Understanding:</strong>
            Better interprets detailed scene descriptions, style, mood, and constraints.
          </span>
        </li>
  
        <li>
          <span class="icon">🧩</span>
          <span>
            <strong>Fast Iteration:</strong>
            Great for generating variations quickly to refine creative direction.
          </span>
        </li>
  
        <li>
          <span class="icon">✅</span>
          <span>
            <strong>Built for Pre-Vis Workflows:</strong>
            Useful for storyboards, creative drafts, and early-stage production planning.
          </span>
        </li>
      </ul>
  
      <div class="when-use">
        <h3>Why Users Choose Google Veo 3.1</h3>
        <ul>
          <li><strong>Pre-visualization</strong> for films, ads, and social campaigns</li>
          <li><strong>Storyboarding</strong> with shot-level prompt control</li>
          <li><strong>Marketing creatives</strong> and rapid concept reels</li>
          <li><strong>Camera-driven prompts</strong> for cinematic style and motion</li>
          <li><strong>Fast iterations</strong> from idea → usable clip variations</li>
        </ul>
  
        <div class="tip">
          <span>💡</span>
          <span>
            <strong>Pro Tip:</strong> Add camera language + lighting + mood:
            “wide establishing shot,” “soft rim light,” “slow dolly-in,” “shallow depth of field.”
          </span>
        </div>
  
        <div class="comparison">
          <h3>What Makes Veo 3.1 Feel “Cinematic” in Real Use</h3>
          <p>
            Veo 3.1 feels cinematic because it translates scene intent into camera, motion, and atmosphere.
            Users typically notice:
          </p>
          <ul>
            <li>Stronger composition and lighting that matches the prompt</li>
            <li>More believable motion and pacing across frames</li>
            <li>Better adherence to shot direction and framing cues</li>
            <li>Faster concept iteration for pre-vis and creative pitches</li>
          </ul>
        </div>
      </div>
  
    </div>
  </div>
  